/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/798/interface/api/cat_8424
 */

import { message } from 'ant-design-vue'
import {
  pdpBannerConfig_add_post,
  pdpBannerConfig_changeOrder_post,
  pdpBannerConfig_edit_post,
  pdpBannerConfig_list_post
} from 'server/modules/8424'

// 添加banner
export const pdpBannerConfig_add_post_ = async function(params, state) {
  const { success, retInfo } = await pdpBannerConfig_add_post(params)
  if (success) {
    state.initList()
    state.changeVisible(0)
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 修改排序
export const pdpBannerConfig_changeOrder_post_ = async function(params, state) {
  const { success, retInfo } = await pdpBannerConfig_changeOrder_post({
    orderNumObjs: params
  })
  if (success) {
    state.initList()
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 编辑banner
export const pdpBannerConfig_edit_post_ = async function(params, state) {
  const { success, retInfo } = await pdpBannerConfig_edit_post(params)
  if (success) {
    state.initList()
    state.changeVisible(0)
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// banner配置列表
export const pdpBannerConfig_list_post_ = async function(params, state) {
  const { success, data, retInfo } = await pdpBannerConfig_list_post(params)
  if (success) {
    const { list, pageNum, pageSize, total } = data
    state.dataSource = list
    state.pagination = {
      ...state.pagination,
      pageNum,
      pageSize,
      total
    }
  } else {
    message.error(retInfo)
  }
}
